export default __webpack_public_path__ + "static/hammer-6bab5001e087bdf38658874dae22c9d5.png";